import { Box, Flex, HStack, Stack, Table } from '@chakra-ui/react';
import { BaseCard } from '@invara-dev/react-base';
import DynamicTableRowWithHeader from '../../../components/DataDisplays/DynamicTableRowWithHeader';
import { addSpacesToCamelCase } from '../../../util/formatters/camelCaseFormater';
import { formatDate } from '../../../common/formatters';
import { formatPhoneNumber } from '../../../util/helpers/crmHelpers';
import { CompanyProject, CompanyProjectGroupType } from './types';
import CompanyProjectStatus from '../../../enums/crm/CompanyProjectStatus';
import { EntityNotesDisplay } from '../../../features/entityNotes/EntityNotesDisplay';
import { EntityNoteQueryType } from '../../../enums/common/EntityNoteQueryType';
import { EntityNoteType } from '../../../enums/common/EntityNoteType';
import { EntityNoteViewer } from '../informationDisplays/shared/EntityNoteViewer';

export const CompanyProjectDisplay = ({ projects }: { projects: CompanyProject[]; isReadOnly?: boolean }) => {
  return (
    <Box>
      {projects.map((value, index) => {
        return (
          <>
            <BaseCard
              header={value.Name}
              key={`${index}-CompanyProjects`}
              padding={'16px'}
              border={'1px solid rgb(221, 222, 224)'}
              boxShadow={'none'}
              borderRadius={'8px'}>
              <Flex gap={'16px'} width={'100%'}>
                <Stack width={'65%'} justifyContent={'space-between'}>
                  <Box width={'100%'} alignSelf={'flex-start'}>
                    <Table.Root padding={12}>
                      <Table.Body>
                        <DynamicTableRowWithHeader obj={value} property={'AssignedToUserName'} />
                        <DynamicTableRowWithHeader
                          obj={value}
                          property={'Status'}
                          render={(d) => CompanyProjectStatus[d]}
                        />
                        <DynamicTableRowWithHeader
                          obj={value}
                          property={'TypeOfGroup'}
                          render={(d) => addSpacesToCamelCase(CompanyProjectGroupType[d])}
                        />
                        <DynamicTableRowWithHeader
                          obj={value}
                          property={'EndDate'}
                          render={(d) => (d ? formatDate(d) : 'Not set')}
                        />
                        <DynamicTableRowWithHeader
                          obj={value}
                          property={'StartDate'}
                          render={(d) => (d ? formatDate(d) : 'Not set')}
                        />
                        <DynamicTableRowWithHeader
                          obj={value}
                          property='Notes'
                          render={(d) =>
                            d.length > 0 && (
                              <Box maxHeight='150px' overflowY='auto' overflowX='hidden'>
                                <EntityNoteViewer notes={d} status={'info'} />
                              </Box>
                            )
                          }
                        />
                      </Table.Body>
                    </Table.Root>
                  </Box>
                  <HStack wrap={'wrap'} alignItems={'flex-start'}>
                    {value.Hotels.map((hotel) => {
                      return (
                        <>
                          <BaseCard
                            header={hotel.Name}
                            key={`${hotel.Name}-${hotel.Id}-companyProjects`}
                            padding={'8px'}
                            border={'1px solid rgb(221, 222, 224)'}
                            boxShadow={'none'}
                            borderRadius={'8px'}>
                            <Table.Root>
                              <Table.Body>
                                <DynamicTableRowWithHeader
                                  obj={hotel}
                                  property={'BookingMethod'}
                                  render={(d) => formatPhoneNumber(d)}
                                />
                                <DynamicTableRowWithHeader obj={hotel} property={'ProjectRate'} />
                              </Table.Body>
                            </Table.Root>
                          </BaseCard>
                        </>
                      );
                    })}
                  </HStack>
                </Stack>
              </Flex>
              {value.Id && (
                <Box>
                  <EntityNotesDisplay
                    entityId={value.Id}
                    queryType={EntityNoteQueryType.CompanyProject}
                    noteDisplayTypes={[EntityNoteType.AgentNote]}
                    height={'300px'}
                    isReadOnly={true}
                    isPinned
                  />
                </Box>
              )}
            </BaseCard>
          </>
        );
      })}
    </Box>
  );
};
